import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import LogoutButton from "./components/LogoutButton.jsx";
import { fetchPlanningPrConfig } from "./apiPlanningPr.js";

export default function OngletPlanningPR() {
  const navigate = useNavigate();

  const [cfg, setCfg] = useState(null);
  const [cfgLoading, setCfgLoading] = useState(true);
  const [cfgError, setCfgError] = useState(null);

  useEffect(() => {
    const loadCfg = async () => {
      try {
        setCfgLoading(true);
        setCfgError(null);
        const json = (await fetchPlanningPrConfig()) || {};
        setCfg(json);
      } catch (e) {
        console.error("Erreur chargement config Planning PR:", e);
        setCfgError(e.message || "Erreur inconnue");
        setCfg(null);
      } finally {
        setCfgLoading(false);
      }
    };
    loadCfg();
  }, []);

  const cfgStatus = useMemo(() => {
    if (!cfg) return null;
    const hasOpened = Array.isArray(cfg.mois_ouverts) && cfg.mois_ouverts.length > 0;
    return hasOpened
      ? { text: "OUVERT", variant: "open" }
      : { text: "FERME", variant: "locked" };
  }, [cfg]);

  const btnStyle = (variant) => {
    const base = {
      padding: "18px 20px",
      borderRadius: "14px",
      cursor: "pointer",
      fontWeight: 700,
      border: "1px solid transparent",
      fontSize: 18,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 10,
      boxShadow: "0 6px 14px rgba(0,0,0,0.08)",
      transition: "transform 0.15s, box-shadow 0.15s, background 0.15s",
      background: "#1f2937",
      color: "#fff",
    };
    if (variant === "outline") {
      return {
        ...base,
        background: "#ffffff",
        color: "#111827",
        border: "1px solid #d1d5db",
        boxShadow: "0 4px 10px rgba(0,0,0,0.04)",
      };
    }
    if (variant === "light") {
      return {
        ...base,
        background: "#111827",
        color: "#f9fafb",
      };
    }
    return base;
  };

  const pillStyle = (variant) => ({
    display: "inline-flex",
    alignItems: "center",
    padding: "8px 12px",
    borderRadius: 9999,
    fontWeight: 800,
    fontSize: 13,
    background: variant === "open" ? "rgba(16, 185, 129, 0.12)" : "rgba(220, 38, 38, 0.10)",
    color: variant === "open" ? "#065f46" : "#b91c1c",
    border: variant === "open" ? "1px solid rgba(16,185,129,0.25)" : "1px solid rgba(220,38,38,0.25)",
  });

  return (
    <div style={{ maxWidth: "900px", margin: "40px auto", padding: "24px", fontFamily: "Inter, sans-serif" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "16px", flexWrap: "wrap", gap: "12px" }}>
        <div>
          <h1 style={{ fontSize: "32px", fontWeight: 800, marginBottom: 8 }}>
            📋 Gestion du planning Port Royal
          </h1>
          <p style={{ color: "#374151", marginBottom: 14 }}>
            Pilotage des desideratas planning Port Royal.
          </p>
        </div>
        <LogoutButton />
      </div>

      <div style={{ border: "1px solid #e5e7eb", background: "#fff", borderRadius: 16, padding: 16, marginBottom: 18, boxShadow: "0 6px 16px rgba(0,0,0,0.04)" }}>
        <div style={{ display: "flex", justifyContent: "space-between", gap: 12, flexWrap: "wrap", alignItems: "center", marginBottom: 10 }}>
          <div>
            <div style={{ fontSize: 16, fontWeight: 900, color: "#111827" }}>
              ⚙️ Pilotage des desiderata (medecins)
            </div>
            <div style={{ fontSize: 13, color: "#6b7280", marginTop: 2 }}>
              Definir les mois ouverts et les restrictions d'acces pour le planning Port Royal.
            </div>
          </div>
          {cfgStatus ? <span style={pillStyle(cfgStatus.variant)}>{cfgStatus.text}</span> : null}
        </div>

        <div style={{ fontSize: 14, color: "#111827", lineHeight: 1.45 }}>
          {cfgLoading ? (
            <div style={{ color: "#6b7280" }}>Chargement de la configuration...</div>
          ) : cfgError ? (
            <div style={{ color: "#b91c1c", fontWeight: 800 }}>
              ❌ Impossible de lire la config : {cfgError}
            </div>
          ) : (
            <>
              <div>
                <b>Mois ouvert(s) :</b>{" "}
                {(Array.isArray(cfg?.mois_ouverts) && cfg.mois_ouverts.length > 0)
                  ? cfg.mois_ouverts.map((m) => m.mois_label || m.mois_cle).join(" • ")
                  : "Aucun"}
              </div>
              <div>
                <b>Mois principal :</b> {cfg?.mois_label || "—"}{" "}
                <span style={{ color: "#6b7280" }}>({cfg?.mois_cle || "—"})</span>
              </div>
              <div>
                <b>Date limite :</b> {cfg?.deadline_affichage || "—"}{" "}
                <span style={{ color: "#6b7280" }}>(ISO: {cfg?.deadline_iso || "—"})</span>
              </div>
            </>
          )}
        </div>

        <div style={{ marginTop: 12, display: "flex", gap: 12, flexWrap: "wrap" }}>
          <button style={btnStyle("outline")} onClick={() => navigate("/responsable/config-desiderata-planning-pr")}>
            ⚙️ Configurer / Ouvrir les desiderata medecins
          </button>
          <button style={btnStyle("outline")} onClick={() => navigate("/desiderata-planning-port-royal")}>
            👀 Voir la page medecins (test)
          </button>
        </div>
      </div>

      <div style={{ border: "1px solid #e5e7eb", background: "#fff", borderRadius: 16, padding: 16, marginBottom: 18, boxShadow: "0 6px 16px rgba(0,0,0,0.04)" }}>
        <div style={{ fontSize: 16, fontWeight: 900, color: "#111827" }}>
          👥 Acces medecins (seniors PR1 interieurs)
        </div>
        <div style={{ fontSize: 13, color: "#6b7280", marginTop: 2 }}>
          Consultez les medecins PR1 (interieur/exterieur). Seuls les interieurs sont eligibles aux desiderata planning PR.
        </div>
        <div style={{ marginTop: 12 }}>
          <button style={btnStyle("outline")} onClick={() => navigate("/responsable/planning-pr-acces-medecins")}>
            👥 Gerer les acces medecins Planning Port Royal
          </button>
        </div>
      </div>

    </div>
  );
}
